export default __webpack_public_path__ + "static/media/super.a8d53864.png";